import Vue from 'vue'
import Vuex from 'vuex'
//import version from "./version";
import { UserService } from "@/services/userservice";
import { MiscService } from "@/services/miscservice";
import { Credentials, Status } from 'vue/types/vue';
import { AxiosResponse } from 'axios';
import { PuzzleService } from './services';

Vue.use(Vuex);


export default new Vuex.Store({
   state: {
      loggedIn: false,
      user: "",
      type: 0,
      version: '',
      pcode: ''
   },
   getters: {
      isLoggedIn: function (state) {
         return state.user !== "";
      },
      user: function (state) {
         return state.user;
      },
      isAdmin: function (state) {
         return state.type === 1;
      },
      version: function (state) {
         return state.version;
      },
      puzzleCode: function (state) {
         return state.pcode;
      }
   },
   mutations: {
      setUser: function (state, payload) {
         state.user = payload;
      },
      setType: function (state, payload) {
         state.type = payload;
      },
      version: function (state, payload) {
         state.version = payload;
      },
      puzzleCode: function (state, payload) {
         state.pcode = payload.toUpperCase();
      }
   },
   actions: {
      checkStatus: async function ({ commit }) {
         let user = "";
         let type = 10;
         try {
            const response: AxiosResponse = await UserService.getUserStatus();
            const status: Status = response.data;
            user = status.user;
            type = status.d;
         } catch (error: any) {
            console.log(error);
            return;
         } finally {

            commit('setUser', user);
            commit('setType', type);
         }
         //return;
      },
      canEdit: async function (context, payload: any) {
         try {
            const res = await PuzzleService.canEditPuzzle(payload.pid);

            return true;
         } catch (error: any) {
            if (error.response.status != 403) {
               console.error("error", error);
            }
            return false;
         }

      },
      login: async function ({ commit, dispatch }, payload: Credentials) {
         try {
            const auth = await UserService.userLogin(payload);
            await dispatch('checkStatus');
            return auth.data === "OK";
         } catch (error: any) {
            console.log("error", error);
            return false;
         }
      },
      logout: async function ({ commit, dispatch }) {

         try {
            return await UserService.userLogout();
         }
         catch (error: any) {
            console.log("ERROR", error);
            throw error;
         }

      },
      appVersion: async function ({ commit }) {
         try {
            const version = await MiscService.appVersion();
            commit('version', version);
         }
         catch (error: any) {
            return 'v1';
         }
      },

   }
})
